export function filterMenuItems<T extends { children?: T[] }>(
  items: T[],
  fn: (item: T) => boolean,
) {
  return items.filter((item) => {
    if (fn(item)) {
      if (item.children) {
        const filteredMenuItems = filterMenuItems(item.children, fn);

        // hide menu item if all children are hidden
        if (filteredMenuItems.length === 0) {
          return false;
        }

        item.children = filteredMenuItems;
      }

      return true;
    }
  });
}
